import React from 'react';
import SocialAccounts from '@/components/common/SocialAccounts';
import type SearchConstituent from '@/types/api/SearchConstituent';
import ColumnMaxMinWidthClasses from '../constants/ColumnMaxMinWidthClasses';

const socialMediaColumn = {
  columnKey: 'socialMedia',
  headerName: 'SOCIAL_MEDIA',
  TableCellProps: {
    className: ColumnMaxMinWidthClasses,
  },
  render: (constituent: SearchConstituent) => {
    return (
      <SocialAccounts
        facebook={constituent.facebook}
        instagram={constituent.instagram}
        linkedin={constituent.linkedin}
        tiktok={constituent.tiktok}
        twitter={constituent.twitter}
        youtube={constituent.youtube}
        className="flex gap-2"
      />
    );
  },
};

export default socialMediaColumn;
